import { Component, EventEmitter, Input, Output } from '@angular/core';

export type ModalVariant = 'info' | 'warning' | 'danger';

@Component({
  selector: 'app-modal',
  standalone: false,
  templateUrl: './modal.html',
  styleUrl: './modal.scss',
})
export class Modal {
  @Input({ required: true }) open = false;
  @Input({ required: true }) title = '';
  @Input() message: string | null = null;
  @Input() highlight: string | null = null;
  @Input() variant: ModalVariant = 'info';
  @Input() primaryText = 'OK';
  @Input() secondaryText: string | null = null;
  @Input() primaryDisabled = false;

  @Output() close = new EventEmitter<void>();
  @Output() primary = new EventEmitter<void>();
  @Output() secondary = new EventEmitter<void>();

  protected onBackdropClick() {
    this.close.emit();
  }
}
